module.exports = __webpack_public_path__ + "media/images/ui-onboard/customisable-c6898723445b6c528fde46b54191a43a.svg";